export default __webpack_public_path__ + "static/media/dot.e680a858.png";